export default __webpack_public_path__ + "static/WebMarketing-cf9de54f31a525e08a215ad4d928157d.jpeg";